module.exports = __webpack_public_path__ + "static/media/(H)-Artesanato-18.4dc95474.jpg";